<script>
    import {_, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig, bonuses} from "../../stores.js";

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function humanize(name) {
        return String(name || '')
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, (c) => c.toUpperCase())
            .trim();
    }

    function setItemDetails() {
        // bonusType is a numeric id on the client (mapped via $bonuses), as with regular boosters.
        const bonusName = typeof gameItem.bonusType === 'string'
            ? gameItem.bonusType
            : ($bonuses?.[gameItem.bonusType] ?? '');
        const label = humanize(bonusName);

        itemDetails.title = label ? `+${gameItem.bonusValue}% ${label}` : $_('EventsWindowTitle');
        itemDetails.description = itemDetails.title;
        itemDetails.icon = bonusName ? bonusName + 'Booster' : 'troopAttackBooster';
        itemDetails.amount = item.amount;
        itemDetails.rarity = gameItem.rarity ? gameItem.rarity : 1;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        $bonuses;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
